/**
 * UNNORMAL — PACK SUEÑO purchase flow
 * /products/pack-sueno → add to cart (AJAX) → /pages/test-de-sueno → /checkout
 */
(function () {
  const STORAGE_KEY = 'unnormal_pack_sueno_checkout';
  const QUIZ_PATH = '/pages/test-de-sueno';
  const PRODUCT_PATH = '/products/pack-sueno';

  const path = window.location.pathname.replace(/\/$/, '') || '/';

  function isPackSuenoProductPage() {
    return path === PRODUCT_PATH || path.endsWith('/products/pack-sueno');
  }

  function isQuizPage() {
    return path === QUIZ_PATH || path.endsWith('/pages/test-de-sueno');
  }

  function getCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url.indexOf('.js') !== -1
        ? window.routes.cart_add_url
        : window.routes.cart_add_url.replace(/\/?$/, '.js');
    }
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function hideAcceleratedCheckout() {
    document.querySelectorAll('.shopify-payment-button, .shopify-payment-button__button, [data-shopify="payment-button"]').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function initProductPage() {
    hideAcceleratedCheckout();

    function bind() {
      const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
      if (!form) return false;

      let btn = form.querySelector('[type="submit"][name="add"]');
      if (!btn) btn = form.querySelector('.product-form__submit');
      if (!btn) return false;

      if (btn.dataset.unnormalBound === '1') return true;
      btn.dataset.unnormalBound = '1';

      btn.type = 'button';
      const label = btn.querySelector('span');
      if (label) label.textContent = 'Comprar';

      btn.addEventListener('click', async function () {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

        const variantInput = form.querySelector('[name="id"]');
        const variantId = variantInput && variantInput.value;
        const qtyInput = form.querySelector('[name="quantity"]');
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        if (!variantId || (variantInput && variantInput.disabled)) {
          alert('Este producto no está disponible en este momento.');
          return;
        }

        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        const spinner = btn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', String(quantity));

        try {
          const response = await fetch(getCartAddUrl(), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'No se pudo añadir el producto al carrito.');
          }

          try {
            sessionStorage.setItem(STORAGE_KEY, '1');
          } catch (e) {}

          window.location.assign(QUIZ_PATH + '?checkout_pending=1');
        } catch (error) {
          console.error('[unnormal-pack-sueno-flow]', error);
          alert(error.message || 'Error al añadir al carrito. Inténtalo de nuevo.');
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        }
      });

      return true;
    }

    if (bind()) return;

    const observer = new MutationObserver(function () {
      if (bind()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(hideAcceleratedCheckout, 500);
    setTimeout(hideAcceleratedCheckout, 1500);
  }

  function initQuizPage() {
    try {
      if (new URLSearchParams(window.location.search).get('checkout_pending') === '1') {
        sessionStorage.setItem(STORAGE_KEY, '1');
      }
    } catch (e) {}

    function maybeRedirectToCheckout() {
      var pending = false;
      try {
        pending = sessionStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {}
      if (!pending) return;

      var confText = document.querySelector('#uq-confirmacion .uq-conf-texto');
      if (confText) {
        confText.innerHTML = 'Cuestionario enviado correctamente. Redirigiendo al pago...';
      }

      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}

      setTimeout(function () {
        window.location.assign('/checkout');
      }, 1500);
    }

    var confirmation = document.getElementById('uq-confirmacion');
    if (!confirmation) return;

    var observer = new MutationObserver(function () {
      if (confirmation.style.display === 'block') {
        maybeRedirectToCheckout();
      }
    });

    observer.observe(confirmation, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  if (isPackSuenoProductPage()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductPage);
    } else {
      initProductPage();
    }
  }

  if (isQuizPage()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initQuizPage);
    } else {
      initQuizPage();
    }
  }
})();
